import { useEffect } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa'

export default function GoogleMaps() {
    const apiKey = 'AIzaSyCfMvkehOqXanwfqCf3S_0_MOJPu5uUnXU'

    useEffect(() => {
        const polyfill = document.createElement('script');
        polyfill.src = 'https://polyfill.io/v3/polyfill.min.js?features=default';
        document.head.appendChild(polyfill);

        const googleapis = document.createElement('script');
        googleapis.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=&v=weekly`;
        googleapis.async = true;
        googleapis.onload = initMap;
        document.body.appendChild(googleapis);

        return () => {
            document.head.removeChild(polyfill);
            document.body.removeChild(googleapis);
        }
    }, []);

    const initMap = () => {
        let map: google.maps.Map;
        const center: google.maps.LatLngLiteral = { lat: 47.3519625, lng: 7.9039523 };

        map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
            center,
            zoom: 16,
        });
        const marker = new google.maps.Marker({
            position: center,
            map: map,
        });
        marker.setLabel({
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            text: 'Alternativmedizin Praxis Olten',
        });
    }

    return (
        <div className="location">
            <h2>Standort</h2>
            <div className="icon-text-inline">
                <FaMapMarkerAlt />
                <a href="https://www.google.com/maps/place/Frohburgstrasse+5,+4600+Olten/@47.3519625,7.9014223,16z/data=!3m1!4b1!4m6!3m5!1s0x479031ca5cc6fb47:0x2e5f8c9640bb3ab3!8m2!3d47.3519589!4d7.9039972!16s%2Fg%2F11pw1xyvc7?entry=ttu&g_ep=EgoyMDI1MTAyNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
                    <address>
                        Frohburgstrasse 5, 4600 Olten
                    </address>
                </a>
            </div>
            <div id="map"></div>
        </div>
    );
}